<template>
  <v-btn outlined class="text-none" color="green" @click="lookupBCLicensee">
    <v-icon left>mdi-magnify</v-icon>
    Lookup BC Licensee
    <component :is="dialog" :customer="customer" @done="dialog = null"/>
  </v-btn>
</template>

<script>
  export default {
    name: 'LookupLicenseeButton',
    props: {
      customer: {type:Object, required:true}
    },
    data() {
      return {
        dialog: null
      }
    },
    methods: {
      lookupBCLicensee() {
        this.dialog = () => import(`@/views/provinces/BC/sales/LookupLicensee`);
      }
    }
  }
</script>